/* KPC custom GA4 events — surfaces that GA4 enhanced ecommerce
   doesn't cover. Pushes via window.gtag directly (Shopify's GA4
   integration registers gtag globally and binds it to G-XLTM4TVKGG).

   Events fired here:
   - wishlist_add: SE Wishlist Engine app button click

   Events fired elsewhere (kept here as reference):
   - variant_grid_click: kpc-variant-picker.js (thumb / grid click)
   - coupon_banner_click: cart-drawer.js & cart-notification.js

   Guard with window.__kpcGa4Bound to prevent double-binding when
   multiple snippets include this script. */

(function () {
  if (window.__kpcGa4Bound) return;
  window.__kpcGa4Bound = true;

  /* Wishlist add. SE Wishlist Engine renders a button with class
     .wishlist-engine-button. The click toggles add/remove (data-added
     attribute on the .wishlist-engine wrapper). We fire on click; if
     data-added flips from "false" to "true" right after, it's an add.
     If "true" to "false", it's a remove. */
  /* Capture phase so we run BEFORE the SE Wishlist Engine click
     handler which may re-render or detach the DOM. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-engine-button');
    if (!btn) return;
    if (typeof window.gtag !== 'function') return;
    var wrap = btn.closest('.wishlist-engine');
    var productId = (wrap && wrap.getAttribute('data-product_id')) || '';
    var variantId = (wrap && wrap.getAttribute('data-variant_id')) || '';
    var wasAdded = wrap && wrap.getAttribute('data-added') === 'true';
    var eventName = wasAdded ? 'wishlist_remove' : 'wishlist_add';
    window.gtag('event', eventName, {
      product_id: productId,
      variant_id: variantId,
    });
  }, true);
})();
